export default {
    rule: '活動規則',
    text1: '投資組合收益榜',
    text2: '去了解',
    text3: '港股',
    text4: '美股',
    text5: '基金',
    text6: '組合成立天數',
    text7: '累計收益率',
    text8: '日漲跌幅',
    text9: '查看完整榜單',
    text10: '免責聲明',
    text11: '以上優惠受條款約束且不與其他活動同時享受優惠，並由復星財富國際控股有限公司（“復星財富”）的全資子公司復星國際證券有限公司（“復星國際證券”）提供，復星國際證券保留隨時修改或取消優惠之權利而不作另行通知。 如有任何爭議，復星國際證券保留最終決定權。 本廣告不構成任何證券、金融產品或工具的邀約、招攬、建議或任何保證。 本廣告由復星國際證券提供，內容並未經香港證券及期貨事務監察委員會審閱。 投資者應注意，投資涉及風險，投資產品價格可昇可跌。 投資前請充分理解投資風險，並諮詢專業顧問（如有需要）。',
    text12: '領取成功',
    text13: '立即使用',
    text14: '溫馨提示',
    text15: '感謝您的支持，活動僅限特定渠道且未交易投資組合的客戶參與',
    text16: '查看更多精選組合',
    text17: '限時領500HKD免佣券',
    text18: '活動已結束',
    text19: '領取失敗，請稍後重試',
    text20: '策略解讀：',
    text21: '限時領免佣券',
    text22: '領券可享免佣交易',
    text23: '投資組合，您的投資利器，現限時可領500HKD免佣券。',
    text24: '登入即可查看詳情',
    text25: '登入即可領券',
    text26: '活動時間',
    text27: '同市場免佣券正在使用中，不可重複使用，具體前往卡券中心查看',
    text28: '立即登入',
    text29: '立即開戶',
    text30: '未知錯誤',
    text31: '感謝您的支持，活動僅限特定渠道客戶參與',
    label1: '姓名',
    label2: '電話',
    label3: '郵箱',
    label4: '預約時間',
    label5: '出發地',
    label6: '年齡',
    label7: '性別',
    placeholder1: '請輸入姓名',
    placeholder2: '請輸入電話',
    placeholder3: '請輸入郵箱(選填)',
    placeholder4: '請選擇時間',
    placeholder5: '請輸入出發城市',
    placeholder6: '請選擇年齡',
    placeholder11: '請選擇針次',
    placeholder12: '請選擇',
    btn: '確認提交',
    closeText: '關閉',
    qsrdqgjzss: '請輸入地區關鍵字搜索',
    cydq: '常用地區',
    phonePlaceholder: '請輸入手機號',
    codePlaceholder: '請輸入驗證碼',
    readText: '我已閱讀並同意',
    userRule: '用戶協議、',
    privateRule: '隱私聲明',
    openWelfare: '立即預約 領取福利',
    openText1: '您已開戶，可前往APP瞭解更多',
    openText2: '去開戶',
    openBtnText1: '下載APP',
    openBtnText2: '去開戶',
    captureText1: '獲取驗證碼',
    captureText2: '秒後重新獲取',
    captureText3: '重新獲取',
    agreeRule: '請選擇協定',
    errorText1: '驗證碼錯誤，請重新輸入',
    downloadApp: '前往APP',
    openText3: '繼續開戶領取福利',
    validatorText: '60s內無須重複獲取驗證碼',
    enterCorrectEmail: '請輸入正確的郵箱格式',
    pageTitle: '復星國際證券開戶',
    ycj: '您已參加過同類型活動，不可重複參與',
    iknow: '知道了',
    firstk: '完成首筆投資組合交易即可領',
}
